import axios from "axios";
import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { ContentRoute, useSubheader } from "../../../../../_metronic/layout";
import { FeatureToggleDialog } from "./Components/FeatureToggleDialog";
import { useFeatureContext } from "./Components/FeatureDataContext";
import { FeatureFilter } from "./Components/FeatureFilter";
import FeatureTable from "./Components/FeatureTable";
import { Snackbar } from "@material-ui/core";
import moment from "moment";
import { SnackbarWrapper } from "../../../Snackbar/SnackbarWrapper";

export const FeatureList = () => {
  const [featureData, setFeatureData] = useState([]);
  const [origData, setOrigData] = useState([]);
  const [loading, setLoading] = useState(false);

  const context = useFeatureContext();

  const suhbeader = useSubheader();
  suhbeader.setTitle("Feature List");
  const featuresUrl = "api/featured_in/";

  async function fetchFeatures() {
    setLoading(true);
    const result = await axios(featuresUrl);


    setFeatureData(result.data.results);
    setOrigData(result.data.results);
    setLoading(false);
  }

  //success error messages
  const [toggleSuccessOpen, setToggleSuccessOpen] = useState(false);
  const [toggleErrorOpen, setToggleErrorOpen] = useState(false);

  const handleClose = () => {
    setToggleSuccessOpen(false);
    setToggleErrorOpen(false);
  };

  //fetching features 
  useEffect(() => {
    fetchFeatures();
  }, []);

  //fetching features 
  useEffect(() => {
    context.refetch && fetchFeatures();
    context.setRefetch(false);
  }, [context.refetch]);

  //Filter Data based on search
  const filterData = (filters) => {
    const newData = origData.filter(function(item) {
      var add = true;

      for (let key in filters) {
        if (filters[key] != "") {
          if (key === "id") {
            if (!(item["featured_in_id"] + "").includes(filters[key])) {
              add = false;
            }
          }

          if (
            key !== "id" &&
            (item[key] === undefined || item[key] != filters[key])
          ) {
            return false;
          }
        }
      }
      return add && true;
    });

    setFeatureData(newData);
  };
  return (
    <div>
      <Snackbar
        anchorOrigin={{
          vertical: "top",
          horizontal: "right",
        }}
        open={
          toggleSuccessOpen ?
            toggleSuccessOpen
            : toggleErrorOpen
        }
        autoHideDuration={3000}
        onClose={handleClose}
      >
        <SnackbarWrapper
          onClose={handleClose}
          variant={toggleSuccessOpen ? "success" : "error"}
          message={
            toggleSuccessOpen
              ? "Status updated successfully"
              : "Something went wrong"
          }
        />
      </Snackbar>
      <div className={`card card-custom`}>
        {/* begin::Header */}
        <div className="card-header border-0 py-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">
              Feature Filters
            </span>
          </h3>
          <div className="card-toolbar">
            <Link
              to="/branch-maintenance/features/add-feature"
              className="btn btn-primary font-weight-bolder font-size-sm"
            >
              Add New Feature
            </Link>
          </div>
        </div>
        {/* end::Header */}

        {/* begin::Body */}
        <div className="card-body py-0">
          <FeatureFilter
            filterData={filterData}
            origData={origData}
            loading={loading}
          />
        </div>
      </div>

      <FeatureTable features={featureData} showActions={true} loading={loading} />

      <ContentRoute path="/branch-maintenance/features/feature-list/:id/activate-feature">
        {({ history, match }) => (
          <FeatureToggleDialog
            history={history}
            show={match != null}
            id={match && match.params.id}
            active_value={1}
            onHide={() => {
              history.push("/branch-maintenance/features/feature-list");
            }}
          />
        )}
      </ContentRoute>
      <ContentRoute path="/branch-maintenance/features/feature-list/:id/de-activate-feature">
        {({ history, match }) => (
          <FeatureToggleDialog
            history={history}
            show={match != null}
            id={match && match.params.id}
            active_value={0}
            onHide={() => {
              history.push("/branch-maintenance/features/feature-list");
            }}
          />
        )}
      </ContentRoute>
    </div>
  );
};
